import type { ReactNode } from 'react';
import { createContext, useEffect, useState } from 'react';

import type { Extension } from '@interhyp/platform-plugin';
import { ExtensionProvider } from '@interhyp/platform-plugin';
import { Spinner } from '@platform/elements';

import type { ModuleName } from '../../types/ModuleName.js';
import { getModuleExtensions } from '../../loader/getModuleExtensions.js';

interface ModuleContextValue {
  name: ModuleName;
}

export const ModuleContext = createContext<ModuleContextValue>(undefined!);

export interface ModuleProviderProps {
  children: ReactNode;
  name: ModuleName;
  provide?: Extension[];
}

export const ModuleProvider = ({ children, name, provide }: ModuleProviderProps) => {
  const [extensions, setExtensions] = useState<Extension[] | undefined>(undefined);

  useEffect(() => {
    void (async () => {
      setExtensions(await getModuleExtensions(name));
    })();
  }, [provide, name]);

  if (extensions === undefined) {
    return (
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <Spinner size={40} />
      </div>
    );
  }

  return (
    <ModuleContext.Provider value={{ name }}>
      <ExtensionProvider extensions={[...extensions, ...(provide ?? [])]}>{children}</ExtensionProvider>
    </ModuleContext.Provider>
  );
};
